import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { usePricingContext } from '../../../contexts/pricing-context';

export const PageSectionPB = (props: any) => {
  const { isMobile, children, classes, title, type } = props;
  const { shouldShowPricingBookPage } = usePricingContext();
  const fontSize = isMobile ? 'sui-text-xl' : 'sui-text-5xl';
  const showNationalAccountNewTitle =
    type === 'NAI' && shouldShowPricingBookPage;

  const renderTitle = () => {
    if (!title) return null;

    if (showNationalAccountNewTitle) {
      return (
        <Typography
          variant="h2"
          color="primary"
          weight="display"
          uppercase
          data-testid="PageSectionPB__new__header__title"
        >
          {title}
        </Typography>
      );
    }

    return (
      <div
        data-testid="PageSectionPB__header"
        className="sui-h-11 sui-border-solid sui-border-primary sui-border-b-1"
      >
        <span
          className={`sui-border-solid sui-border-b-2 sui-border-accent ${fontSize}`}
          data-testid="PageSectionPB__header__title"
        >
          {title}
        </span>
      </div>
    );
  };

  return (
    <div className="sui-w-full sui-mb-10" data-testid="PageSectionPB">
      {renderTitle()}
      <div data-testid="PageSectionPB__content">
        <div className={classes}>{children}</div>
      </div>
    </div>
  );
};
